<div class="field" [formGroup]="formGroup">
    <label class="field__title" [for]="id">{{label ? label : ""}}</label>
    <input [id]="id" [placeholder]="placeholder ? placeholder : ''" [formControlName]="id"
        [ngClass]="[formGroup.get(id)!.errors && formGroup.get(id)!.touched ? 'error' : '']"
        (focusout)="focusOutHandle($event)" mask="00000-000" />
    <form-error [id]=" id" [formGroup]="formGroup"></form-error>
</div>